module.exports = __webpack_public_path__ + "img/home-hero_cn.2cce84c.jpg";